export const settingsLightTheme = {
  '--setting-bgc-1': '#f8f8f8',
  '--setting-font-c-1': '#333',
  '--setting-font-c-2': '#666',
  '--setting-font-c-3': '#f75b3d',
  '--setting-font-c-4': '#41CC8B',
  '--setting-border-c-1': '#3b3e49',
  '--setting-border-c-2': 'linear-gradient(341deg, #0989e5 9%, #37dffd 83%)',
}
export const settingsDarkTheme = {
  '--setting-bgc-1': '#23262f',
  '--setting-font-c-1': '#fff',
  '--setting-font-c-2': '#9fa7b3',
  '--setting-font-c-3': '#f75b3d',
  '--setting-font-c-4': '#41CC8B',
  '--setting-border-c-1': '#3b3e49',
  '--setting-border-c-2': 'linear-gradient(341deg, #0989e5 9%, #37dffd 83%)',
}
